import { Injectable } from '@angular/core';
import {Observable, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class CaptchaService {

  constructor() { }

  private captcha: Subject<string> = new Subject<string>();
  public captcha$: Observable<string> = this.captcha.asObservable();

  newCaptcha(captchaCode: string) {
    if (captchaCode) {
      this.captcha.next(captchaCode);
    }
  }

}
